export default __webpack_public_path__ + "static/media/bershka.0546ddcd.png";